import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-edit-past-event',
  templateUrl: './edit-past-event.component.html',
  styleUrls: ['./edit-past-event.component.css']
})
export class EditPastEventComponent {
  @Input() event: { name: string; category: string; } | undefined;
  

  categories: string[] = ['Music', 'Sports', 'Tech', 'Education'];

  onSubmit() {
    
  }
}
